import { render, staticRenderFns } from "./DatasetForms.vue?vue&type=template&id=5b1738e3"
import script from "./DatasetForms.vue?vue&type=script&lang=js"
export * from "./DatasetForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports